/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCheckout201ResponseAllOfData } from './CreateCheckout201ResponseAllOfData';
import {
    CreateCheckout201ResponseAllOfDataFromJSON,
    CreateCheckout201ResponseAllOfDataFromJSONTyped,
    CreateCheckout201ResponseAllOfDataToJSON,
} from './CreateCheckout201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateCheckout201ResponseAllOf
 */
export interface CreateCheckout201ResponseAllOf {
    /**
     * 
     * @type {CreateCheckout201ResponseAllOfData}
     * @memberof CreateCheckout201ResponseAllOf
     */
    data: CreateCheckout201ResponseAllOfData;
}

/**
 * Check if a given object implements the CreateCheckout201ResponseAllOf interface.
 */
export function instanceOfCreateCheckout201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateCheckout201ResponseAllOfFromJSON(json: any): CreateCheckout201ResponseAllOf {
    return CreateCheckout201ResponseAllOfFromJSONTyped(json, false);
}

export function CreateCheckout201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckout201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateCheckout201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function CreateCheckout201ResponseAllOfToJSON(value?: CreateCheckout201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCheckout201ResponseAllOfDataToJSON(value.data),
    };
}

